export default "__VITE_ASSET__34fade61__"